import { ApiClient } from '../../../lib/api/ApiClient.types';
import {
  budgetExpenseUpdateToWire,
  resourceSlotUpdateToWire
} from './adapters/mutationToWire';
import {
  toWireBudgetExpenseCreateInput,
  toWireBudgetExpenseLineCreateInput,
  toWireBudgetExpensePatch,
  toWireResourceSlotCreateInput,
  toWireResourceSlotPatch
} from './resourcingMoney.http';
import { ResourcingApi } from './resourcing.api';

export function createResourcingApi(config: {
  client: ApiClient;
}): ResourcingApi {
  const { client } = config;

  return {
    async updateResourceSlot(productionId, slotId, patch) {
      return client.put(
        `/productions/${productionId}/associations/resource_slots/${slotId}`,
        {
          data: toWireResourceSlotPatch(resourceSlotUpdateToWire(patch)),
          token: true
        }
      );
    },

    async createResourceSlot(productionId, data) {
      return client.post<{ id: number }>(
        `/productions/${productionId}/associations/resource_slots`,
        { data: toWireResourceSlotCreateInput(data), token: true }
      );
    },

    async deleteResourceSlot(productionId, slotId) {
      await client.del(
        `/productions/${productionId}/associations/resource_slots/${slotId}`,
        { token: true }
      );
    },

    async reorderResourceSlots(slots) {
      await client.put(`/reorder/resource_slots`, {
        data: { reorder: slots },
        token: true
      });
    },

    async addBudgetExpense(productionId, data) {
      return client.post<{ id: number }>(
        `/productions/${productionId}/associations/budget_expenses`,
        { data: toWireBudgetExpenseCreateInput(data), token: true }
      );
    },

    async updateBudgetExpense(productionId, expenseId, patch) {
      return client.put(
        `/productions/${productionId}/associations/budget_expenses/${expenseId}`,
        {
          data: toWireBudgetExpensePatch(budgetExpenseUpdateToWire(patch)),
          token: true
        }
      );
    },

    async deleteBudgetExpense(productionId, expenseId) {
      await client.del(
        `/productions/${productionId}/associations/budget_expenses/${expenseId}`,
        { token: true }
      );
    },

    async orderBudgetExpenses(_productionId, expenses) {
      await client.put('/reorder/budget_expenses', {
        data: { reorder: expenses },
        token: true
      });
    },

    async createExpense(data) {
      return client.post<{ id: number }>('/expenses', {
        data: toWireBudgetExpenseLineCreateInput(data),
        token: true
      });
    },

    async deleteExpense(expenseLineId) {
      await client.del(`/expenses/${expenseLineId}`, { token: true });
    },

    async deleteResourceSlotAssignment(_productionId, _slotId, assignmentId) {
      await client.del(`/resource_slot_assignments/${assignmentId}`, {
        data: { archived: true },
        token: true
      });
    },

    async createProductionGroup(group) {
      return client.post<{ id: number }>('/groups/productions', {
        data: group,
        token: true
      });
    },

    async updateProductionGroup(groupId, data) {
      await client.put(`/groups/${groupId}`, { data, token: true });
    },

    async deleteProductionGroup(productionId, groupId) {
      await client.del(`/groups/${groupId}`, { token: true });
    },

    async reorderProductionGroups(groups) {
      await client.put('/reorder/groups', {
        data: { reorder: groups },
        token: true
      });
    }
  };
}
